"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TruncatedTextWithCursorTooltip = TruncatedTextWithCursorTooltip;
var _react = require("react");
var _reactDom = require("react-dom");
var _tooltip = require("@design-generated/tooltip");
var _tooltip2 = require("@design-generated/tooltip.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TOOLTIP_OFFSET_BELOW_CURSOR_PX = 16;
var TOOLTIP_VIEWPORT_MARGIN_PX = 8;
function horizontalPlacementOnRoomierSideOfCursor(cursorLeftPx) {
  var viewportWidthPx = document.documentElement.clientWidth;
  var roomRightOfCursorPx = viewportWidthPx - cursorLeftPx - TOOLTIP_VIEWPORT_MARGIN_PX;
  var roomLeftOfCursorPx = cursorLeftPx - TOOLTIP_VIEWPORT_MARGIN_PX;
  if (roomRightOfCursorPx >= roomLeftOfCursorPx) return {
    left: cursorLeftPx,
    maxWidth: roomRightOfCursorPx
  };
  return {
    right: viewportWidthPx - cursorLeftPx,
    maxWidth: roomLeftOfCursorPx
  };
}
function TruncatedTextWithCursorTooltip(_ref) {
  var text = _ref.text;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipPosition = _useState2[0],
    setTooltipPosition = _useState2[1];
  function showTooltipBelowCursorWhenTruncated(event) {
    var textElement = event.currentTarget;
    if (textElement.scrollWidth <= textElement.clientWidth) return;
    setTooltipPosition({
      cursorLeftPx: event.clientX,
      topPx: event.clientY + TOOLTIP_OFFSET_BELOW_CURSOR_PX
    });
  }
  var tooltip = tooltipPosition ? /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    role: "tooltip",
    className: "pointer-events-none fixed z-floating w-max",
    style: _objectSpread(_objectSpread({}, horizontalPlacementOnRoomierSideOfCursor(tooltipPosition.cursorLeftPx)), {}, {
      top: tooltipPosition.topPx
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip2.TooltipContext.Provider, {
      value: {
        tooltipLabel: text,
        tooltipShowCaret: false,
        kbd: {}
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.TooltipScreen, {})
    })
  }), document.body) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "min-w-0 truncate",
      onMouseMove: showTooltipBelowCursorWhenTruncated,
      onMouseLeave: function onMouseLeave() {
        return setTooltipPosition(null);
      },
      children: text
    }), tooltip]
  });
}